module.exports = __webpack_public_path__ + "img/occupation_inf_4.b6e88fcb.png";